import { render } from "./3DWordCloud.vue?vue&type=template&id=7faf7072&scoped=true"
import script from "./3DWordCloud.vue?vue&type=script&lang=js"
export * from "./3DWordCloud.vue?vue&type=script&lang=js"

import "./3DWordCloud.vue?vue&type=style&index=0&id=7faf7072&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7faf7072"]])

export default __exports__